export default __webpack_public_path__ + "static/media/qtravel.544bdf94.svg";